import axios from 'axios'

import { BASE_URL } from '@/api/api.constants'

export const deleteKpiAssignment = async (id: string): Promise<void> => {
  try {
    await axios.delete(`${BASE_URL}/kpi/assignments/${id}/`)
  } catch (error) {
    throw error
  }
}
